export const ModelListBR = [
    {
        'group':'BlueRock',
        'name':'Google',
        'models':
        [
            // {name:'SATELLITEO',url:'./models/satellite2.glb'},
            {name:'SATELLITE',url:'./models/googleLayout.glb'},
        ]   

    },
    {
        'group':'BlueRock',
        'name':'Drone',
        'models':
        [
            // {name:'BLOCKD',url:'./models/dumisa/drone_blockd.glb'},
            // // {name:'BLOCKD_16K',url:'./models/dumisa/drone_blockd.glb'},
            // {name:'Redhat',   url:'./models/drone/redhat_pit.glb', translation:[0,0,0]},
            {name:'Redhat_1k',url:'./models/drone/redhat_pit_1k.glb' , rotation:[-Math.PI/2,0,0]},
            {name:'Redhat_2k',url:'./models/drone/redhat_pit_2k.glb', rotation:[-Math.PI/2,0,0]},
            {name:'Redhat_4k',url:'./models/drone/redhat_pit_4k.glb', rotation:[-Math.PI/2,0,0]},
            {name:'Redhat_8k',url:'./models/drone/redhat_pit_8k.glb', rotation:[-Math.PI/2,0,0]},
            {name:'Dumptruck',type:'animation'},
            {name:'Bluerock_1K',url:'./models/drone/bluerockA_1k.glb' , rotation:[-Math.PI/2,0,0]},
            {name:'Bluerock_2K',url:'./models/drone/bluerockA_2k.glb' , rotation:[-Math.PI/2,0,0]},
            {name:'Bluerock_4K',url:'./models/drone/bluerockA_4k.glb' , rotation:[-Math.PI/2,0,0]},
            {name:'Bluerock_8K',url:'./models/drone/bluerockA_8k.glb' , rotation:[-Math.PI/2,0,0]},
            // {name:'BlurockDrone',url:'./models/dumisa/block2A_rotated.glb'},
        ]   

    },
    {
        'group':'BlueRock',
        'name':'2025',
        'models':
        [
            {name:'orebody_2025',url:'./models/bluerock/orebody_design.glb'},
            {name:'pit1a_design',url:'./models/bluerock/pit1_design.glb'},
            {name:'pit1b_design',url:'./models/bluerock/pit2_design.glb'},
            {name:'pit2_design',url:'./models/dumisa/bluerockpitA1.glb'},
            {name:'pit3_design',url:'./models/bluerock/pit3_design.glb'},
            ]   

    },
    {
        'group':'BlueRock',
        'name':'2020',
        'models':
        [
            {name:'BIF',url:'./models/bif.glb'},
            {name:'FELSIC',url:'./models/felsic.glb'},
            {name:'SCHIST',url:'./models/schist.glb'},
            {name:'OREBODY',url:'./models/orebody.glb'},
            ]   

    },

    {
        'group':'BlueRock',
        'name':'BLUEROCKA',
        'models':
        [
            {name:'OREBODY_BLUEROCK',url:'./models/dumisa/OREBODY_2024.glb'},
            {name:'BlueRock_PitA1',url:'./models/dumisa/bluerockpitA1.glb'},
            {name:'BlueRock_PitA2',url:'./models/dumisa/bluerockpitA2.glb'},
            {name:'BluerockOreInPitA1',url:'./models/dumisa/oreinpitA1.glb'},
            {name:'BluerockOreInPitA2',url:'./models/dumisa/oreinpitA2.glb'}
            ]   

    },

    {
        'group':'BlueRock',
        'name':'REDHAT',
        'models':
        [
            {name:'OREBODY_REDHAT',url:'./models/dumisa/redhatore1.glb'},
            {name:'OREBODY_REDHAT1',url:'./models/dumisa/redhatore2.glb'},
            {name:'RedHat_Pit',url:'./models/dumisa/redhatpit.glb'},
            ]   

    },

    {
        'group':'BlueRock',
        'name':'REDHAT_0825',
        'models':
        [
            {name:'RH_OreV1',url:'./models/dumisa/redhatore_0825.glb'},
            {name:'RH_OreV2',url:'./models/dumisa/redhatore_0825_tm.glb'},
            {name:'RH_Pit1',url:'./models/dumisa/redhatpit_0825_1.glb'},
            {name:'RH_Ore1',url:'./models/dumisa/redhatore_0825_1.glb'},
            // {name:'RH_Pit2',url:'./models/dumisa/redhatpit_0825_2.glb'},
            {name:'RH_Pit2',url:'./models/dumisa/redhatpit_0825_4.glb'},
            {name:'RH_Ore2',url:'./models/dumisa/redhatore_0825_4.glb'},
            {name:'RH_Pit3',url:'./models/dumisa/redhatpit_0825_3.glb'},
            {name:'RH_Ore3',url:'./models/dumisa/redhatore_0825_3.glb'},
            ]   

    },

    
    {
        'group':'Holes',
        'name':'Holes',
        'models':
        [
            // {type:'holesassays',name:'2020Holes',assay_url:'./files/PREVIOUS/AssayData.csv' , hole_url:'./files/PREVIOUS/HoleData.csv'},
            {type:'holesassays',name:'OldHoles',assay_url:'./files/DUMISA/AssayData.csv' , hole_url:'./files/DUMISA/HoleData.csv'},
            {type:'holesassays',name:'2025Holes',assay_url:'./files/2025/AssayData.csv' , hole_url:'./files/2025/HoleData.csv'},
            ]   

    },

    {
        'group':'Bluerock',
        'name':'Dumisa.BlockModel',
        'models':
        [   
            // {type:'blockmodel',name:'BRBM',url:'./files/brbm_short1.zip', dx:0,dy:0,dz:0,size:'4mb',grade:'AU'},
            {type:'blockmodel',name:'BlockModel',url:'./files/blockmodel.zip', dx:0,dy:0,dz:0,size:'0.2mb',grade:'AU'},
            // {type:'plannedholes',name:'PlannedHoles',url:'./files/DUMISA/PlannedHoles.zip',dataset:'RC_PLAN',color:'white'},
        ]   

    }
    
]